import type { ComponentChildren } from 'preact';
import { BlockInfoIcon } from './BlockInfoIcon';
import { cn } from './types';

interface ChartCardProps {
  title?: string;
  infoBlockId?: string;
  icon?: ComponentChildren;
  controls?: ComponentChildren;
  children: ComponentChildren;
  className?: string;
}

/**
 * Standard chart section: title + controls header, flexible chart body.
 * Controls stack below title on mobile (see primitives.css).
 */
export function ChartCard({
  title,
  infoBlockId,
  icon,
  controls,
  children,
  className,
}: ChartCardProps) {
  return (
    <section className={cn('ui-chart-card', className)}>
      {(title || controls) && (
        <header className="ui-chart-card__header">
          {title && (
            <div className="ui-chart-card__heading">
              {icon && (
                <span className="ui-chart-card__title-icon" aria-hidden="true">
                  {icon}
                </span>
              )}
              <h2 className="ui-chart-card__title">{title}</h2>
              {infoBlockId && <BlockInfoIcon blockId={infoBlockId} />}
            </div>
          )}
          {controls && <div className="ui-chart-card__controls">{controls}</div>}
        </header>
      )}
      <div className="ui-chart-card__body">{children}</div>
    </section>
  );
}
